module.exports = __webpack_public_path__ + "img/display-icon3.9d81efd2.png";